import { CohortPledgeView } from '@app/view-creator/CohortPledgeViewCreator';
import apiResponse from './ApiResponse';
import { ApiService } from './ApiService';

export class PledgeStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async getCohortPledge(groupId: number) {
    try {
      const result = await this.api.get(`Cohort/${groupId}/pledge`);
      return apiResponse.Success<CohortPledgeView>(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async updateCohortPledge(pledge: CohortPledgeView) {
    try {
      // Update the pledge amount to the sum of individual and external amounts
      pledge.amount = pledge.individualAmount + pledge.externalAmount;
      const result = await this.api.put(`Cohort/${pledge.cohortId}/pledge`, pledge);
      return apiResponse.Success<CohortPledgeView>(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
